"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LobbyDescriptionWindow;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LobbyDescriptionWindowModule = _interopRequireDefault(require("./LobbyDescriptionWindow.module.scss"));

var _barbarianmark = _interopRequireDefault(require("./img/marks/barbarianmark.gif"));

var _highelfmark = _interopRequireDefault(require("./img/marks/highelfmark.gif"));

var _woodelfmark = _interopRequireDefault(require("./img/marks/woodelfmark.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getIconForRaceId(id) {
  switch (id) {
    case "barbarian":
      return _barbarianmark.default;

    case "highelf":
      return _highelfmark.default;

    case "woodelf":
      return _woodelfmark.default;

    default:
      throw new Error("Unknown raceId '".concat(id, "'."));
  }
}
/*
TODO: region texts
Rog Imperial City (Rog Capital)
This is the capital city of the Rog Empire with its long
history. As the Emperor depraved and the nobles
corrupted, the Empire has been growing weaker
everyday.
*/


// eslint-disable-next-line complexity
function LobbyDescriptionWindow(_ref) {
  var raceId = _ref.raceId,
      classId = _ref.classId,
      _ref$isSelectingRegio = _ref.isSelectingRegion,
      isSelectingRegion = _ref$isSelectingRegio === void 0 ? false : _ref$isSelectingRegio,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  var text = "Please select a race.";

  if (isSelectingRegion) {
    text = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Please select a nation you want to join."), /*#__PURE__*/_react.default.createElement("p", null, "Depending on what nation you join you have different special abilities and can sell or buy items for a better price in the belonging town."));
  } else if (classId) {
    text = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, "--- ", classId[0].toUpperCase() + classId.substring(1), " ---"), " ", /*#__PURE__*/_react.default.createElement("div", null, "TODO: class description."));
  } else if (raceId) {
    text = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, "=== ", raceId[0].toUpperCase() + raceId.substring(1), " ==="), " ", /*#__PURE__*/_react.default.createElement("div", null, "TODO: race description."));
  }

  var imgSrc = raceId ? getIconForRaceId(raceId) : "";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LobbyDescriptionWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyDescriptionWindowModule.default.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyDescriptionWindowModule.default.text
  }, text), /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyDescriptionWindowModule.default.icon
  }, imgSrc !== "" && /*#__PURE__*/_react.default.createElement("img", {
    src: imgSrc,
    alt: ""
  }))));
}